import { GalleryCardFiltersButton } from '../../GalleryCardFilters/GalleryCardFiltersButton/GalleryCardFiltersButton'
import { GalleryControlsGroupby } from '../GalleryControlsGroupby/GalleryControlsGroupby'
import { GalleryControlsReset } from '../GalleryControlsReset/GalleryControlsReset'
import { GalleryControlsRole } from '../GalleryControlsRole/GalleryControlsRole'
import { GalleryControlsSearch } from '../GalleryControlsSearch/GalleryControlsSearch'
import { GalleryControlsSize } from '../GalleryControlsSize/GalleryControlsSize'
import { GalleryControlsSortby } from '../GalleryControlsSortby/GalleryControlsSortby'
import { GalleryControlsView } from '../GalleryControlsView/GalleryControlsView'

import styles from './GalleryControlsDesktop.module.scss'

export const GalleryControlsDesktop = () => (
  <div className={styles.container}>
    <div className={styles.inner}>
      <GalleryControlsReset />
      <GalleryControlsRole />
      <GalleryControlsSize />
      <GalleryControlsView />
      <GalleryControlsGroupby />
      <GalleryControlsSortby />
      <GalleryCardFiltersButton />
      <GalleryControlsSearch variant='desktop' />
    </div>
  </div>
)
